import React from "react";
import { Tooltip } from "../../Tooltip";
import { Button } from "../../Button";

interface Props {
  isBlock?: boolean;
  isDisabled: boolean;
  isFamilyPlan?: boolean;
  isBusinessPlan?: boolean;
  onClick: () => void;
}

// Cant conditionally render the content of the tooltip so we've gotta
// duplicate the button
export const ContinueButton = (props: Props) => {
  const { isDisabled, isFamilyPlan, isBlock, isBusinessPlan, onClick } = props;
  const tooltipContent = isFamilyPlan
    ? "Please add your family"
    : isBusinessPlan
    ? "Please add your employees"
    : "Please select a plan";

  return (
    <>
      {isDisabled ? (
        <Tooltip content={tooltipContent}>
          <div>
            <Button
              text="Go to checkout"
              textOnlyWithBorder
              block={isBlock}
              disabled
            />
          </div>
        </Tooltip>
      ) : (
        <Button
          text="Go to checkout"
          primary
          block={isBlock}
          onClick={onClick}
        />
      )}
    </>
  );
};
